export interface SortFilterOption<T extends string> {
  value: T
  label: string
  enabled: boolean
}

export interface ClientFileSortFilterType {
  sortOption: SortFilterOption<server.dto.ClientFileSort>
}

export const DefaultClientFileSortFilter: server.dto.ClientFileSort = "dateDesc"

export const ClientFileSortOptions: Array<SortFilterOption<server.dto.ClientFileSort>> = [
  {
    label: RESX.GeneralLabels.Name,
    value: "nameAsc",
    enabled: true
  },
  {
    label: `${RESX.DateTime.lblDate} ${RESX.GeneralLabels.Ascending}`,
    value: "dateAsc",
    enabled: true
  },
  {
    label: `${RESX.DateTime.lblDate} ${RESX.GeneralLabels.Descending}`,
    value: "dateDesc",
    enabled: true
  },
  {
    label: RESX.File.Size,
    value: "sizeDesc",
    enabled: true
  }
];

export const getSortOption = (value: server.dto.ClientFileSort) => {
  return ClientFileSortOptions.find(s => s.value === value);
};

export const initialClientFileSortFilter: ClientFileSortFilterType = {
  sortOption: getSortOption(DefaultClientFileSortFilter)
};
